// 产品介绍
<template>
  <div class="cpjs width1200">
    <div class="item-desc">
      <p class="text1">资源组成</p>
      <p class="text2">
        IP 资源来源于运营商原生资源。独享 IP 以及带宽。IP
        长期稳定不变，不可切换。
      </p>
    </div>
    <div class="item-desc">
      <p class="text1">资源属性</p>
      <p class="text2">固定家庭住宅 IP、企业专线 IP。</p>
    </div>
    <div class="item-desc">
      <p class="text1">支持多样化的代理协议</p>
      <p class="text2">HTTP、SOCKS5</p>
    </div>
    <div class="item-desc">
      <p class="text1">资源覆盖</p>
      <p class="text2">全国主要的一线城市</p>
    </div>
    <div class="item-desc">
      <p class="text1">适用场景</p>
      <dl class="d-flex">
        <dd>
          <img :src="require('@/assets/images/cpjs15.png')" alt="" />
          <span>数据采集</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs18.png')" alt="" />
          <span>游戏挂机</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs17.png')" alt="" />
          <span>广告投放和营销</span>
        </dd>
        <dd>
          <img :src="require('@/assets/images/cpjs20.png')" alt="" />
          <span>防关联店铺助力出海</span>
        </dd>
      </dl>
    </div>
    <div class="item-desc">
      <p class="text1">支持定制化开发</p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
};
</script>

<style lang="less" scoped>
.cpjs {
  padding: 50px 0 116px;
  .item-desc {
    margin-bottom: 30px;
    p {
      color: #000;
      &.text1 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 6px;
      }
      &.text2 {
        font-size: 18px;
      }
    }
    ul {
      margin-left: 20px;
      li {
        list-style: disc;
        &::marker {
          color: #27a7e7;
          font-size: 24px;
        }
      }
    }
    dl {
      margin-top: 20px;
      dd {
        margin-right: 76px;
        img {
          margin-right: 10px;
        }
      }
    }
  }
  .cpjs-imgs {
    margin: 0 0 30px;
  }
}
@media (max-width: 768px) {
  .cpjs {
    padding: 4% 0;
  }
  .cpjs .item-desc {
    margin-bottom: 2%;
  }
  .cpjs .item-desc p.text1,
  .cpjs .item-desc ul li::marker {
    font-size: 16px;
  }
  .cpjs .item-desc p.text2,
  .cpjs .item-desc ul li {
    font-size: 14px;
  }
  .cpjs .item-desc dl {
    flex-wrap: wrap;
  }
  .cpjs .item-desc dl dd {
    font-size: 14px;
    margin-right: 0;
    width: 50%;
  }
}
@media (max-width: 375px) {
  .cpjs .item-desc dl dd {
    width: 100%;
  }
}
</style>
